import {CardDetailsResponse, CardGroupResponse} from '@/root/models/card';

import {api} from '@/shared/utils/api';

// group code 없는 경우
export const getCardGroupByCardId = (cardId: string) => {
  return api<CardGroupResponse>('get', `/api/cards/groups`, {cardId});
};

export const getCardGroup = (groupCode: string) => {
  return api<CardGroupResponse>('get', `/api/cards/groups/${groupCode}`);
};

export const getCardDetails = (cardId: string) => {
  return api<CardDetailsResponse>('get', `/api/cards/${cardId}/details`);
};
